// Turns a GoKwik KwikForms postMessage into an analytics event, or into nothing.
//
// This exists for analytics only. The webhook is what records a lead, and the SDK
// draws its own success screen, so nothing here affects the form.
//
// The output is built from a short allowlist — the event name and the form's id
// and name — instead of copying the message and removing the sensitive fields.
// kf:submitted carries the customer's phone, name and email, and the page loads
// Google Tag Manager, so anything pushed to dataLayer is reachable by every tag
// marketing attaches to it. An allowlist means a field GoKwik adds to the message
// later stays out by default rather than leaking by default.

// A Map rather than an object literal: an object inherits keys such as
// "constructor" from its prototype, so a message of that type would look up as
// a known event and push a function into dataLayer.
const EVENT_NAMES = new Map([
    ['kf:form_start', 'kwikform_start'],
    ['kf:form_error', 'kwikform_error'],
    ['kf:submitted', 'kwikform_submitted'],
]);

const asId = (value) => {
    if (typeof value === 'string' || typeof value === 'number') return String(value).slice(0, 100);
    return undefined;
};

export const toAnalyticsEvent = (message) => {
    if (message === null || typeof message !== 'object') return null;

    const event = EVENT_NAMES.get(message.type);
    if (!event) return null;

    // GoKwik's guide shows the payload under `data`, and the lifecycle events
    // describe theirs as { formName, formId, ... }; the submission itself uses the
    // webhook's snake_case names. Both spellings are read.
    const payload = message.data !== null && typeof message.data === 'object' ? message.data : {};

    return {
        event,
        kwikform_form_id: asId(payload.formId ?? payload.form_id),
        kwikform_form_name: asId(payload.formName ?? payload.form_name),
    };
};
